import { animate, spring } from "motion";

export default class NavDesktop {
  constructor(navbar) {
    this.navbar = navbar;

    this.subNavs = $(this.navbar).find(
      ".page-navbar__menu .menu-item-has-children",
    );
    this.subNavs.on("mouseenter", this.mouseenter.bind(this));
    this.subNavs.on("mouseleave", this.mouseleave.bind(this));
    this.subNavs.on("focusin", this.mouseenter.bind(this));
    this.subNavs.on("focusout", this.mouseleave.bind(this));
  }

  mouseenter(event) {
    const sub = event.currentTarget.querySelector("ul.sub-menu");
    if (!sub) return;
    this.showSub(sub);
  }

  mouseleave(event) {
    const sub = event.currentTarget.querySelector("ul.sub-menu");
    if (!sub) return;
    this.hideSub(sub);
  }

  showSub(sub) {
    sub.previousElementSibling.setAttribute("aria-expanded", true);

    const translateX = sub.parentNode.closest("ul.sub-menu") ? "100%" : "0";

    animate(
      sub,
      {
        opacity: 1,
        pointerEvents: "auto",
        transform: `translateX(${translateX}) translateY(0)`,
      },
      { duration: 0.5, easing: spring() },
    );
  }

  hideSub(sub) {
    sub.previousElementSibling.setAttribute("aria-expanded", false);

    const translateX = sub.parentNode.closest("ul.sub-menu") ? "100%" : "0";
    animate(
      sub,
      {
        opacity: 0,
        pointerEvents: "none",
        transform: `translateX(${translateX}) translateY(4px)`,
      },
      { duration: 0.5, easing: spring() },
    );
  }
}
